// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__root-TawPgB","svg__lh32G":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__lh32G-KThxid","svgLh32G":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__lh32G-KThxid","svg__rUr3X":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__rUr3X-p1LnQF","svgRUr3X":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__rUr3X-p1LnQF"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__root-TawPgB\",\"svg__lh32G\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__lh32G-KThxid\",\"svgLh32G\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__lh32G-KThxid\",\"svg__rUr3X\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__rUr3X-p1LnQF\",\"svgRUr3X\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicShareButton-module__svg__rUr3X-p1LnQF\"}";
        // 1793541991377
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  